import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScOfferWithLine = styled.div`
  text-align: center;
  text-transform: uppercase;
  margin-top: 32px;
  width: 100%;
  max-width: 576px;
  @media (${device.mobile}) {
    margin-top: 0;
  }
  .title {
    font-size: 28px;
    line-height: 28px;
    font-weight: 700;
    color: ${({ theme }) => theme.yellowColor};
    letter-spacing: 0.84px;
    @media (${device.mobile}) {
      font-size: 20px;
      line-height: 20px;
      letter-spacing: 0.4px;
    }
  }
  .description-first {
    margin-top: 8px;
    font-size: 44px;
    line-height: 44px;
    font-weight: 700;
    letter-spacing: 1.32px;
    .bonus__text-fs {
      display: inline-block;
    }
    &.fr-ca,
    &.fr-ch {
      font-size: 40px;
      letter-spacing: 1px;
    }

    &.en-nz {
      letter-spacing: 0px;
    }
    @media (${device.mobile}) {
      font-size: 36px;
      line-height: 36px;
      letter-spacing: 1.08px;
      &.fr-ca,
      &.fr-ch {
        font-size: 36px;
        letter-spacing: normal;
      }
    }
  }

  .description-second {
    margin-top: 8px;
    font-size: 44px;
    line-height: 44px;
    font-weight: 700;
    letter-spacing: 1.32px;
    @media (${device.mobile}) {
      font-size: 36px;
      line-height: 36px;
      letter-spacing: 1.08px;
      &.fr-ca,
      &.fr-ch {
        font-size: 30px;
      }
    }
  }
  .line {
    height: 2px;
    width: 100%;
    max-width: 576px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.2);
    margin: 24px 0 24px 0;
    @media (${device.mobile}) {
      margin: 16px 0 16px 0;
    }
  }
`;
